<template>
  <div v-if="!loading" class="simple-card" style="background-color: #F8F8F8">
    <h3 class="simple-card-title" style="margin: 0">{{$t("pages.exams.ratingResults.leaderboard")}}</h3>
    <div v-if="leaderboard.length > 0" id="leaderboard">
      <div class="ribbon"></div>
      <table>
        <tr v-for="(user, index) in leaderboard.slice(0, 6)" :key="user.username">
          <td v-if="user.place" class="number">{{user.place + 1}}</td>
          <td v-else-if="index == 0" class="number" style="color: white">{{index + 1}}</td>
          <td v-else class="number">{{index + 1}}</td>
          
          <td v-if="user.place" class="name" style="font-weight: bold; color: #00a65a; ">{{user.username}}</td>
          <td v-else-if="index == 0" class="name" style="color: white">{{user.username}}</td>
          <td v-else class="name">{{user.username}}</td>
          
          <td v-if="user.place" class="points" >{{user.ratingGlicko}}</td>
          <td v-else-if="index == 0" class="points" style="color: white">
            {{user.ratingGlicko}}
            <img v-if="index == 0" class="gold-medal" src="https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true" alt="gold medal"/>
          </td>
          <td v-else class="points">
            {{user.ratingGlicko}}
            <img v-if="index == 0" class="gold-medal" src="https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true" alt="gold medal"/>
          </td>
        </tr>
      </table>
    </div>
    <div v-else>
      <div style="padding: 20px; text-align: center;">
        <span>{{$t('pages.exams.ratingResults.leaderboardEmpty')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import RatingQuizButton from '@/components/rating/cards/RatingQuizButton.vue'
import Rest from '@/services/rest'

export default {
  name: 'leaderboard',
  components: {RatingQuizButton},
  props: ['gid'],
  data () {
    return {
      currentUser: null,
      leaderboard: [],
      toggleLeaderboard: true,
      loading: true
    }
  },
  created () {
    this.showLeaderboard()
  },
  methods: {
    showLeaderboard () {
      Rest.request('GET', '/rating/leaderboard/' + this.gid).then((data) => {
        this.leaderboard = data.userRatings
        this.currentUser = this.$store.getters.getUser
        let index = this.leaderboard.map(function (e) {
          return e.username
        }).indexOf(this.currentUser.username)

        if (index === -1) {
          this.toggleLeaderboard = false
        } else if (index > 5) {
          this.leaderboard[5] = this.leaderboard[index]
          this.leaderboard[5].place = index
        }
      })
      this.loading = false
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../../assets/k6styles/cards';

#leaderboard {
  margin-top: 30px;
  width: 100%;
  position: relative;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  color: #141a39;
  cursor: default;
}

tr {
  transition: all 0.2s ease-in-out;
  border-radius: 0.2rem;
}

td {
  height: 5.2rem;
  font-family: "Rubik", sans-serif;
  font-size: 1.4rem;
  padding: 1rem 2rem;
  position: relative;
}

.number {
  width: 4rem;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: left;
}

.name {
  text-align: left;
  font-size: 1.3rem;
}

.points {
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 5.2rem;
  border: 0;
}

.points:first-child {
  width: 10rem;
}

.gold-medal {
  height: 3rem;
  width: 3rem;
  margin-left: 1.5rem;
  margin-right: 0;
}

.ribbon {
  width: calc(100% + 1rem);
  border-radius: 8px;
  height: 5.5rem;
  top: -0.5rem;
  background-color: #0073b7;
  position: absolute;
  left: -0.5rem;
  -webkit-box-shadow: 0px 15px 11px -6px #7a7a7d;
  box-shadow: 0px 10px 11px -6px #a6a6a9;
}

.ribbon::before {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  left: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

.ribbon::after {
  content: "";
  height: 1.5rem;
  width: 1.5rem;
  bottom: -0.8rem;
  right: 0.35rem;
  transform: rotate(45deg);
  background-color: #0073b7;
  position: absolute;
  z-index: -1;
}

</style>


// WEBPACK FOOTER //
// Leaderboard.vue?0d1dfa11